import { CheckCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const PRODUCT_GROUPS = [
  { category: "Dexcom", items: ["G7 Sensor", "G6 Twin Pack", "G6 Transmitter", "Sensors 3-Pack", "Receivers"] },
  { category: "FreeStyle Libre", items: ["Libre 3 Sensor", "Libre 3 Plus", "Libre 2 Sensor", "Libre 14-Day", "Readers"] },
  { category: "Omnipod", items: ["Omnipod 5", "DASH 5-Pack", "DASH 10-Pack", "Classic Pods", "PDM Controllers"] },
  { category: "Medtronic", items: ["780G Pump", "Guardian 4", "MiniMed", "Quick-Set", "Reservoirs"] },
  { category: "Tandem", items: ["Autosoft XC", "Autosoft 90", "t:slim Pump"] },
  { category: "Insulin & More", items: ["Humulin N/R", "Novolin", "BD Needles", "Lancets"] },
  { category: "FreeStyle Strips", items: ["Lite 100ct", "Lite 50ct", "Lite 50ct NFR", "100ct Retail", "50ct Retail"] },
  { category: "Accu-Chek", items: ["Aviva Plus 100ct", "Aviva Plus 50ct", "Guide 100ct", "Guide 50ct", "Smartview 100ct", "Smartview 50ct"] },
  { category: "Contour Next", items: ["100ct Retail", "70ct", "50ct Retail", "50ct Red Label", "50ct Yellow Label", "35ct"] },
  { category: "OneTouch", items: ["Verio 100", "Verio 50", "Verio 25", "Ultra 100", "Ultra 50", "Ultra 25"] },
  { category: "ReliOn", items: ["Prime 100ct", "Prime 50ct", "Prime 25ct"] },
  { category: "True Metrix", items: ["50ct (Black Trivida Box)", "100ct (Black Trivida Box)"] }
];

export const ProductsWeBuy = ({ onOpenForm }) => (
  <section className="py-24 md:py-32 bg-[#F5F5F0]" data-testid="products-section">
    <div className="container-custom">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-[#1F2937] mb-4" style={{ fontFamily: "Manrope" }}>
          Products We Buy
        </h2>
        <p className="text-lg text-[#4B5563] max-w-2xl mx-auto">
          We purchase a wide variety of diabetic supplies. Check out what we're looking for!
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-12">
        <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
          <div className="relative h-[450px] overflow-hidden">
            <img
              src="https://customer-assets.emergentagent.com/job_strip-buy/artifacts/ci7by4mw_IMG_2177.png"
              alt="Sell Dexcom G7 Jacksonville - We buy Dexcom G6, CGM Sensors, Omnipod, and Medtronic supplies for instant cash"
              className="absolute w-full scale-110"
              style={{ top: "-22%", left: 0 }}
            />
          </div>
        </div>
        <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
          <div className="relative h-[450px] overflow-hidden">
            <img
              src="https://customer-assets.emergentagent.com/job_strip-buy/artifacts/d7ykip9o_IMG_2178.png"
              alt="Cash for Omnipods Jacksonville - Sell FreeStyle Libre, Medtronic pumps, insulin vials, and diabetic supplies"
              className="absolute w-full scale-110"
              style={{ top: "-22%", left: 0 }}
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-12">
        {PRODUCT_GROUPS.map((group) => (
          <div key={group.category} className="bg-white rounded-xl p-4 shadow-md">
            <h4 className="font-bold text-[#0F5132] mb-2 text-sm uppercase tracking-wide">{group.category}</h4>
            <ul className="text-sm text-[#4B5563] space-y-1">
              {group.items.map((item) => (
                <li key={`${group.category}-${item}`} className="flex items-center gap-1">
                  <CheckCircle className="w-3 h-3 text-[#0F5132] flex-shrink-0" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="text-center">
        <Button
          onClick={onOpenForm}
          className="bg-[#EA580C] hover:bg-[#C2410C] text-white rounded-full px-8 py-6 text-lg font-semibold shadow-lg"
          data-testid="products-sell-btn"
        >
          Sell Your Supplies
        </Button>
      </div>
    </div>
  </section>
);
